export default "__VITE_ASSET__195$MBd2__"